import Header from '@/components/Header';
import Footer from '@/components/Footer';
import { Card } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Shield } from 'lucide-react';

const About = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />

      <div className="flex-1 py-24">
        <div className="container mx-auto max-w-3xl">
          <div className="text-center mb-16">
            <Badge className="mb-4" variant="secondary">About Us</Badge>
            <h1 className="text-4xl md:text-5xl font-heading font-black tracking-tighter mb-6">
              Our Story
            </h1>
          </div>

          <Card className="p-8 border-zinc-200">
            <div className="flex justify-center mb-6">
              <Shield className="h-16 w-16 text-primary" />
            </div>
            
            <div className="space-y-6 leading-relaxed">
              <p>
                Penocio was built by writers who understand the challenges of working with AI tools. We saw that existing AI humanizers either didn't work or were prohibitively expensive.
              </p>

              <p>
                We set out to build something better: a tool that actually works against major detection systems, offers transparent pricing, and gives users real value.
              </p>

              <p>
                Today, Penocio is trusted by over 50,000 students, writers, content creators, and professionals who need reliable AI text humanization.
              </p>

              <p>
                Our mission is simple: help people write with confidence, whether they're using AI assistance or not.
              </p>
            </div>
          </Card>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default About;
